<div class="steps-bar">
  <div class="labels">
    <span class="counter">Paso {{ currentStepNumber() }} de {{ totalSteps }}</span>
    <span class="title">{{ currentStepTitle() }}</span>
  </div>

  <div
    class="track"
    role="progressbar"
    [attr.aria-valuenow]="currentStepNumber()"
    aria-valuemin="1"
    [attr.aria-valuemax]="totalSteps"
    [attr.aria-label]="'Progreso: paso ' + currentStepNumber() + ' de ' + totalSteps"
  >
    <div class="fill" [style.width.%]="progressRatio() * 100"></div>
  </div>
</div>
